import { IAccountManualFormCreate } from 'src/types'

export const initialValues: IAccountManualFormCreate = {
  email: null,
  account_holder: '',
  address: null,
  website: null,
}
